export default __webpack_public_path__ + "static/media/socks.dcf64325.svg";